import React from 'react'
import { Form, Card, Select } from 'antd'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import GeneralEditor from 'components/elements/GeneralEditor'
import Scroller from 'components/elements/Scroller'
import {BreedForm} from 'components/partials'
import {
  breedActions
} from 'actions'

class Edit extends React.Component {
  constructor(){
    super()
    this.formRef = React.createRef()
    this.state = {
      officeHours:[],
      visible: false,
      createBreedVisible: false,
      breedSearch: ''
    }
    this.breedSearchTimeout = ''
    this.handleCancel = this.handleCancel.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleBreedSearch = this.handleBreedSearch.bind(this)
    this.handleBreedChange = this.handleBreedChange.bind(this)
    this.handleNewBreed = this.handleNewBreed.bind(this)
  }
  handleBreedChange(value){
    if(value === 'new' || value == 'speciesSearchPrompt'){
      if(value === 'new'){
        this.setState({
          createBreedVisible: true
        })
      }

      setTimeout(()=>{ 
        // Huge Hack
        // Huge Hack
        // Huge Hack
        // Huge Hack
        this.form && this.form.setFieldsValue({breedID: ''});
      }, 1)
    }
  }
  handleBreedSearch(value){
    if(this.breedSearchTimeout){
      clearTimeout(this.breedSearchTimeout)
    }
    this.breedSearchTimeout = setTimeout(()=>{this.breedSearch(value)},600)
  }
  handleSubmit(values){
    Object.keys(values).forEach((key)=>{
      if(!values[key]){
        values[key] = null
      }
    })

    if(this.props.type === 'new'){
      breedActions.create(values)
    }
    
    if(this.props.type === 'edit'){
      breedActions.update({
        ...this.current,
        ...values
      })
    }
    this.props.history.push(`/admin/breeds/${this.current.id}`)
  }
  get current(){
    return this.props.current || {}
  }
  handleCancel(){
    if(this.current.id){
        this.props.history.push(`/admin/breeds/${this.current.id}`)
    } else {
        this.props.history.push(`/admin/breeds`)
    }
  }
  componentDidUpdate(previousProps){
    if(JSON.stringify(previousProps) !== JSON.stringify(this.props)){
      this.form && this.form.resetFields()
      this.setState(this.state)
    }
  }
  handleNewBreed(value){
    if(value === 'new'){
      this.setState({
        createBreedVisible: true
      })
      setTimeout(()=>{
        // Huge Hack
        // Huge Hack
        // Huge Hack
        // Huge Hack
        this.form && this.form.setFieldsValue({breedID: ''});
      }, 1)
    }
  }
  get form(){
    return this.formRef.current
  }
  render() {
    const initialValues = {
      name: this.current.name,
      description: this.current.description,
      userType: this.current.userType || '',
      classificationID: this.current.classificationID
    }
    return (
      <div className='edit-switch'>
        <Form ref={this.formRef} initialValues={initialValues}  onFinish={this.handleSubmit}>
          <GeneralEditor onCancel={this.handleCancel} onSave={true}>
            <Scroller>
              <Card bordered={false}>
                <BreedForm formRef={this.formRef} breed={this.current} />
              </Card>
            </Scroller>
          </GeneralEditor>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    classifications: state.classifications
  }
}

export default withRouter(
  (
    connect(mapStateToProps)(Edit)
  )
)